module.exports = __webpack_public_path__ + "static/media/Դեղնած-դաշտերին-Մարիետա-Բադալյան.0c36a2b0.mp3";